import { PANEL, PANEL_BORDER, PANEL_PAGE_BG, PANEL_SURFACE } from "./panelTokens";

/** Tenant sidebar navigasyon renk token'ları */
export const PANEL_SIDEBAR = {
  bg: PANEL_SURFACE,
  border: PANEL_BORDER,
  text: PANEL.text.body,
  textMuted: PANEL.text.muted,
  textActive: PANEL.accent.text,
  hoverBg: PANEL_PAGE_BG,
  activeBg: PANEL.accent.soft,
  accent: PANEL.accent.main,
  sectionLabel: PANEL.text.label,
  scrollbarThumb: PANEL.fill.hover,
};
